import { useOutletContext } from "react-router-dom";

import Page from "~/components/Page";
import { useTrans } from "~/hooks/useTrans";
import { getProjectBreadcrumb } from "~/utils/breadcrumbs";
import { apiGetProject, apiGetProjectJournal } from "~/providers/api";
import { IClientProject } from "~/providers/client-interfaces";
import { IOutlet } from "~/interfaces";
import { IAdminProject, IAdminJournalItem } from "~/providers/admin-interfaces";
import Loader from '~/components/Loader';
import { myUseState } from "~/hooks/myUseState";
import AdminJournalFilter, { TFilter, TFilterAction } from "~/components/AdminJournalFilter";
import TableControls from "~/components/TableControls";
import AdminJournalsTable from "~/tables/AdminJournalsTable";
import { useLang } from "~/hooks/useLang";

interface IState {
	loading: boolean;
	isDirty: boolean;
	errorMsg: string;
	project: IClientProject | IAdminProject;
	journals: Array<IAdminJournalItem>;
	journalsOrig: Array<IAdminJournalItem>;
}

const INIT_STATE: IState = {
	loading: true,
	isDirty: false,
	errorMsg: "",
	project: null,
	journals: [],
	journalsOrig: [],
};

export default function ProjectFinancialPage() {
	const isInternal = true;
	const { trans } = useTrans();
	const { lang } = useLang();
	const { state, updateState, setState } = myUseState<IState>(INIT_STATE);
	const { params }: IOutlet = useOutletContext();

	function onFilter(filterType: TFilter, filterAction: TFilterAction, filterValue: string) {
		setState(prev => {
			let journals = prev.journalsOrig.filter(item => {
				switch (filterType) {
					case "email":
						return item.appUser.name.indexOf(filterValue) !== -1;

					default:
				}

				return true;
			});

			if (filterAction !== "all") {
				journals = journals.filter(journalItem => journalItem.action === filterAction);
			}

			return {
				...prev,
				journals,
			};
		});
	}

	async function loadData() {
		updateState(INIT_STATE);

		const [projectData, journalData] = await Promise.all([
			apiGetProject(isInternal ? "admin" : "client", params.projectId, lang),
			apiGetProjectJournal(params.projectId, lang),
		]);

		updateState({
			loading: false,
			// castecna data
			...projectData.noErrors
				? {
					project: projectData.data,
				}
				: {},
			...journalData.noErrors
				? {
					journals: journalData.data.slice(),
					journalsOrig: journalData.data,
				}
				: {},
			errorMsg: [
				...projectData.errors,
				...journalData.errors,
			].join(", "),
		});
	}

	function onPageLoad(isAuthorized: boolean) {
		if (isAuthorized) {
			loadData();
		}
	}

	/* eslint-disable no-magic-numbers */
	return <Page checkLogged={true} title={trans("projectJournalPage.title")} breadcrumbs={getProjectBreadcrumb(trans, isInternal, state.project, trans("projectJournalPage.title"))}
		checkInternalRole={isInternal ? "salesman" : "none"} onLoad={onPageLoad} isDirty={state.isDirty} seoTitleTrans="seo.title.admin.journal">
		{ state.loading && <Loader msg={trans("loadingData")} /> }
		<TableControls className="adminServicesPage__tableControls">
			<div className="adminServicesPage__filterCont">
				<AdminJournalFilter onFilter={onFilter} />
			</div>
		</TableControls>
		<AdminJournalsTable loading={state.loading} items={state.journals} />
	</Page>;
}
